import createIcon from '../../createIcon';

/**
 * @component @name PhonelinkErase
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgOC4yTDEyIDcuMkw4IDExLjJMNCA3LjJMMyA4LjJMNyAxMi4yTDMgMTYuMkw0IDE3LjJMOCAxMy4yTDEyIDE3LjJMMTMgMTYuMkw5IDEyLjJMMTMgOC4yWk0xOSAxSDlDNy45IDEgNyAxLjkgNyAzVjZIOVY0SDE5VjIwSDlWMThIN1YyMUM3IDIyLjEgNy45IDIzIDkgMjNIMTlDMjAuMSAyMyAyMSAyMi4xIDIxIDIxVjNDMjEgMS45IDIwLjEgMSAxOSAxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhonelinkErase = createIcon('PhonelinkErase', [
  [
    'path',
    {
      d: 'M13 8.2L12 7.2L8 11.2L4 7.2L3 8.2L7 12.2L3 16.2L4 17.2L8 13.2L12 17.2L13 16.2L9 12.2L13 8.2ZM19 1H9C7.9 1 7 1.9 7 3V6H9V4H19V20H9V18H7V21C7 22.1 7.9 23 9 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1Z',
      key: '4tr3lx',
    },
  ],
]);

export default PhonelinkErase;
